<template>
  <div class="w-100 advanced-search d-flex column flex-grow">
    <vx-card>
      <div class="vx-row gutter-half mt-3 d-flex align-center" v-if="!isHcLocale">
        <div class="vx-col custom-input-group concepts-search" style="flex-grow: 1;">
          <div class="d-flex align-center">
            <div class="label">
              Search:
            </div>
            <div class="relative flex-grow">
              <vs-input loading v-model="filters._search"
                        style="width: 100%"
                        @keypress.enter="fetchItems(false)"
                        placeholder="Type a topic to search related content."
                        class="has-icons mb-0"
              />
              <div class="icons">
                <feather-icon v-if="filters._search" icon="XIcon"
                              svgClasses="h-6 w-6 cursor-pointer"
                              @click="clearSearch"
                              style="opacity: 0.7; margin-right: 5px;" />
                <div v-if="isLoading" class="vs-input__loading"
                     style="margin-left: 5px;" />
                <feather-icon
                  v-else
                  style="margin-right: 5px;"
                  icon="SearchIcon" svgClasses="h-6 w-6" :class="{'active-search-btn': isLoading}" />
              </div>
            </div>
            <vs-button id="search-btn" class="ml-5" color="primary" @click="fetchItems(false)" :disabled="!filters._search.trim()">
              Search
            </vs-button>
          </div>
        </div>
      </div>
      <div v-if="$route.meta.lmEnabled && !isHcLocale"
           class="vx-row gutter-half mb-5 mt-3 d-flex align-center">
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/4 " :class="{'filter-disabled': !goalsExamsSubjects.length}">
          <div class="d-flex align-center">
            <span class="label">Curriculum: </span>
            <v-select name="LM"
                      class="flex-grow  right"
                      placeholder="Select Curriculum"
                      :options="curriculums"
                      :disabled="!goalsExamsSubjects.length"
                      label="name"
                      :searchable="false"
                      :value="filters.lm_format"
                      @input="selectCurriculum">
              <template #list-header>
                <li style="text-align: center" v-if="!$store.state.learningMapFormats.length">Loading LM Formats...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/4" :class="{'filter-disabled': !goals.length}">
          <div class="d-flex align-center">
            <span class="label">Goal: </span>
            <v-select name="Goal"
                      class="flex-grow  right"
                      placeholder="Select Goal"
                      :options="goals"
                      label="display_name"
                      @input="selectGoal"
                      :searchable="false"
                      :value="filters.goal"
                      :disabled="!goals.length">
              <template #list-header>
                <li style="text-align: center" v-if="!goals.length">Loading Goals...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/4" :class="{'filter-disabled': !exams.length}">
          <div class="d-flex align-center">
            <span class="label">Grade: </span>
            <v-select name="Grade"
                      class="flex-grow  right"
                      placeholder="Select Grade"
                      :options="exams"
                      label="display_name"
                      @input="selectExam"
                      :searchable="false"
                      :value="filters.exam"
                      :disabled="!exams.length">
              <template #list-header>
                <li style="text-align: center" v-if="!exams.length">Loading Grades...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/4" :class="{'filter-disabled': !subjects.length}">
          <div class="d-flex align-center">
            <span class="label">Subject: </span>
            <v-select name="subject"
                      class="flex-grow  left"
                      placeholder="Select Subject"
                      :options="subjects"
                      label="display_name"
                      :searchable="true"
                      :disabled="!subjects.length"
                      :value="filters.subject"
                      @input="selectSubject">
              <template #list-header>
                <li style="text-align: center" v-if="!subjects.length">Loading Subjects...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div v-if="$route.meta.lmEnabled && !isHcLocale"
           class="vx-row gutter-half mb-5 d-flex align-center">
        <div class="vx-col w-full sm:w-full md:w-1/3">
          <div class="d-flex align-center" :class="{'filter-disabled': !units.length}">
            <span class="label">Unit: </span>
            <v-select name="unit"
                      class="flex-grow  left"
                      placeholder="Select Unit"
                      :options="units"
                      label="title"
                      :disabled="!units.length"
                      :searchable="true"
                      @input="selectUnit"
                      :value="filters.unit">
              <template #list-header>
                <li style="text-align: center" v-if="!units.length">Loading Units...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>

          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/3">
          <div class="d-flex align-center" :class="{'filter-disabled': !chapters.length}">
            <span class="label">Chapter: </span>
            <v-select name="chapter"
                      class="flex-grow  right"
                      placeholder="Select Chapter"
                      :options="chapters"
                      label="title"
                      :disabled="!chapters.length"
                      :searchable="true"
                      @input="selectChapter"
                      :value="filters.chapter">
              <template #list-header>
                <li style="text-align: center" v-if="!chapters.length">Loading Chapters...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>

          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !topics.length}">
          <div class="d-flex align-center">
            <span class="label">Topic: </span>
            <v-select name="topic"
                      class="flex-grow  right"
                      placeholder="Select Topic"
                      :options="topics"
                      label="title"
                      :clearable="false"
                      :searchable="true"
                      :disabled="!topics.length"
                      @input="selectTopic"
                      :value="filters.topic">
              <template #list-header>
                <li style="text-align: center" v-if="!topics.length">Loading Topics...</li>
              </template>
              <template #no-options="{ search, searching, loading }">
                <span></span>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="vx-row gutter-half">
        <div class="vx-col w-full overflow-x-auto">
          <vx-input-group class="custom-input-group">
            <div class="d-flex">
              <span class="label">Media Type: </span>
              <div class="vx-input-group-append flex-grow">
                <div class="append-text btn-addon">
                  <vs-button
                    color="primary"
                    type="border"
                    v-for="(v, i) in types.filter(t => !isHcLocale || t.value === 'any' || hcData[t.value])"
                    :key="i"
                    @click="toggleMediaType(v.value)"
                    class="radiobtn"
                    :class="{selected: $store.state.globalSearchAssetTypes.indexOf(v.value) !== -1}">
                    {{ v.name }}
                  </vs-button>
                </div>
              </div>
            </div>
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row gutter-half mb-5 d-flex align-center">
        <div class="vx-col w-full sm:w-full"
             v-if="!isHcLocale"
             :class="{
          'filter-disabled': !['coobos'].some((s) => $store.state.globalSearchAssetTypes.includes(s)),
          'md:w-1/3': $store.state.globalSearchAssetTypes.includes('image'),
          'md:w-1/2': !$store.state.globalSearchAssetTypes.includes('image')
        }">
          <vx-input-group class="custom-input-group">
            <div class="d-flex">
              <span class="label">Voiceover: </span>
              <div class="vx-input-group-append flex-grow">
                <div class="append-text btn-addon">
                  <vs-button
                    color="primary"
                    type="border"
                    v-for="(v, i) in ['yes', 'no']"
                    :key="i"
                    @click="setRadioBtn('voiceover', v)"
                    class="radiobtn"
                    :disabled="!['coobos'].some((s) => $store.state.globalSearchAssetTypes.includes(s))"
                    :class="{selected: filters.voiceover === v}">
                    {{ v[0].toUpperCase() + v.substring(1) }}
                  </vs-button>
                </div>
              </div>
            </div>
          </vx-input-group>
        </div>
        <!--        <div class="vx-col w-full sm:w-full md:w-1/3">-->
        <!--          <div class="d-flex align-center">-->
        <!--          <span class="label">Subject: </span>-->
        <!--          <v-select name="subject"-->
        <!--                    class="flex-grow  left"-->
        <!--                    placeholder="Select Subject"-->
        <!--                    :options="subjects"-->
        <!--                    label="name"-->
        <!--                    :searchable="false"-->
        <!--                    :clearable="false"-->
        <!--                    :disabled="!subjects.length"-->
        <!--                    @input="() => { fetchItems() }"-->
        <!--                    v-model="filters.subject">-->
        <!--            <template #no-options="{ search, searching, loading }">-->
        <!--              <span></span>-->
        <!--            </template>-->
        <!--          </v-select>-->

        <!--        </div>-->
        <!--        </div>-->
        <!-- <div class="vx-col w-full sm:w-full md:w-1/3">
          <div class="d-flex align-center">
            <span class="label">Licence: </span>
            <v-select
              class="flex-grow  left"
              name="licence"
              placeholder="Select Licence"
              :options="licences"
              v-model="filters.licence"
              label="name"
              :searchable="false"
              :clearable="false"
              @input="() => { fetchItems() }"
              :reduce="item => item.value" />
          </div>
        </div> -->
        <div class="vx-col w-full sm:w-full ml-auto"
             v-if="!$route.meta.onlyUs"
             :class="{
              'md:w-1/3': $store.state.globalSearchAssetTypes.includes('image') && !isHcLocale,
              'md:w-1/2': !$store.state.globalSearchAssetTypes.includes('image') || isHcLocale
        }">
          <div class="d-flex align-center">
            <span class="label">Language: </span>
            <v-select
              class="flex-grow  left"
              name="currentLanguage"
              :options="[{ name: 'English (India)', code: 'en' }, ...hcLanguages, ...$store.state.languages]"
              v-model="filters.locale"
              label="name"
              :searchable="false"
              :clearable="false"
              @input="onLangChange"
              :reduce="item => item.code" />
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/3" v-if="$store.state.globalSearchAssetTypes.includes('image') && !isHcLocale">
          <div class="d-flex align-center">
            <span class="label">Image Type: </span>
            <v-select
              class="flex-grow  left"
              name="imageType"
              :options="imageTypes"
              v-model="filters.imageType"
              label="name"
              :searchable="false"
              :clearable="false"
              @input="() => { fetchItems() }"
              :reduce="item => item.value" />
          </div>
        </div>
      </div>
      <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters && isReviewedFilters && !isHcLocale">
        <div class="vx-col w-full sm:w-full md:w-1/2">
          <div class="d-flex">
            <span class="label">Academic Reviewed: </span>
            <div class="vx-input-group-append flex-grow">
              <div class="append-text btn-addon">
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('academic_reviewed', true)"
                  class="radiobtn"
                  :class="{selected: filters.academic_reviewed && filters.academic_reviewed !== 'any'}">
                  Yes
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('academic_reviewed', false)"
                  class="radiobtn"
                  :class="{selected: !filters.academic_reviewed}">
                  No
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('academic_reviewed', 'any')"
                  class="radiobtn"
                  :class="{selected: filters.academic_reviewed === 'any'}">
                  Any
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/2">
          <div class="d-flex">
            <span class="label">Artist Reviewed: </span>
            <div class="vx-input-group-append flex-grow">
              <div class="append-text btn-addon">
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('artist_reviewed', true)"
                  class="radiobtn"
                  :class="{selected: filters.artist_reviewed && filters.artist_reviewed !== 'any'}">
                  Yes
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('artist_reviewed', false)"
                  class="radiobtn"
                  :class="{selected: !filters.artist_reviewed}">
                  No
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('artist_reviewed', 'any')"
                  class="radiobtn"
                  :class="{selected: filters.artist_reviewed === 'any'}">
                  Any
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters && !isHcLocale">
        <div class="vx-col w-full sm:w-full md:w-1/2">
          <div class="d-flex">
            <span class="label">Visibility: </span>
            <div class="vx-input-group-append flex-grow">
              <div class="append-text btn-addon">
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('visibility', 'internal_only')"
                  class="radiobtn"
                  :class="{selected: filters.visibility == 'internal_only'}">
                  Internal Only
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('visibility', 'public')"
                  class="radiobtn"
                  :class="{selected: filters.visibility == 'public'}">
                  B2B
                </vs-button>
                <!-- <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('visibility', 'public')"
                  class="radiobtn"
                  :class="{selected: filters.visibility == 'public'}">
                  Public
                </vs-button> -->
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('visibility', 'any')"
                  class="radiobtn"
                  :class="{selected: filters.visibility == 'any'}">
                  Any
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/2">
          <div class="d-flex">
            <span class="label">Readiness: </span>
            <div class="vx-input-group-append flex-grow">
              <div class="append-text btn-addon">
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('published', false)"
                  class="radiobtn"
                  :class="{selected: !$store.state.globalSearchPublished}">
                  Draft
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('published', true)"
                  class="radiobtn"
                  :class="{selected: $store.state.globalSearchPublished && $store.state.globalSearchPublished !== 'any'}">
                  Published
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('published', 'any')"
                  class="radiobtn"
                  :class="{selected: $store.state.globalSearchPublished === 'any'}">
                  Any
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters && this.filtersObj.asset_type.includes('3D')">
        <div class="vx-col w-full sm:w-full md:w-1/2">
          <!-- <div class="d-flex">
            <span class="label">3D animation: </span>
            <div class="vx-input-group-append flex-grow">
              <div class="append-text btn-addon">
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('is_animated', true)"
                  class="radiobtn"
                  :class="{selected: filters.is_animated}">
                  Yes
                </vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  @click="setRadioBtn('is_animated', false)"
                  class="radiobtn"
                  :class="{selected: !filters.is_animated}">
                  No
                </vs-button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!--      <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters">-->
      <!--        <div class="vx-col w-full sm:w-full md:w-1/2">-->
      <!--          <div class="d-flex">-->
      <!--            <span class="label">AR Readiness: </span>-->
      <!--            <div class="vx-input-group-append flex-grow">-->
      <!--              <div class="append-text btn-addon">-->
      <!--                <vs-button-->
      <!--                  color="primary"-->
      <!--                  type="border"-->
      <!--                  @click="setRadioBtn('ar_reviewed', true)"-->
      <!--                  class="radiobtn"-->
      <!--                  :class="{selected: filters.ar_reviewed && filters.ar_reviewed !== 'any'}">-->
      <!--                  Yes-->
      <!--                </vs-button>-->
      <!--                <vs-button-->
      <!--                  color="primary"-->
      <!--                  type="border"-->
      <!--                  @click="setRadioBtn('ar_reviewed', false)"-->
      <!--                  class="radiobtn"-->
      <!--                  :class="{selected: !filters.ar_reviewed}">-->
      <!--                  No-->
      <!--                </vs-button>-->
      <!--                <vs-button-->
      <!--                  color="primary"-->
      <!--                  type="border"-->
      <!--                  @click="setRadioBtn('ar_reviewed', 'any')"-->
      <!--                  class="radiobtn"-->
      <!--                  :class="{selected: filters.ar_reviewed === 'any'}">-->
      <!--                  Any-->
      <!--                </vs-button>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </vx-card>
    <vx-card>
      <div class="search-total-items">
        <div class="search-total-items-title">Total items:</div>
        <div class="search-total-items-value">
          {{
            !isHcLocale
              ? totalItemsCount.toLocaleString("en")
              : this.filtersObj.asset_type.includes('3D')
                ? "3D models are available in multiple languages, click on each asset to explore. The language filter will only work for English (India) and Indic languages."
                : "Samples"
          }}
        </div>
        <!--        <div class="search-total-items-title">Total assets:</div> <div class="search-total-items-value">{{ totalItemsAmp }}</div>-->
        <!--        <div class="search-total-items-title">Total simulations:</div> <div class="search-total-items-value">{{ totalItemsSimulations}}</div>-->
        <!--        <div class="search-total-items-title">Total lessons:</div> <div class="search-total-items-value">{{ totalItemsCoobos}}</div>-->
        <!--        <div class="search-total-items-title">Total videos:</div> <div class="search-total-items-value">{{ totalItemsVideos}}</div>-->
      </div>
    </vx-card>
    <div class="pr">
      <div class="loader-block loader-block2" v-if="isLoading" style="min-height: 200px;">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <div class="vx-row">
        <SmartClickWrapper class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 lg:w-1/5 d-flex"
             v-for="(item, index) in items" :key="index" :onClick="() => showGlobalAsset(item)">
          <GlobalAssetItem :item="item" :show-images="showImages" :isMyLibrary="true" />
        </SmartClickWrapper>
      </div>
      <div class="mb-5" style="text-align: center"
           v-if="showLoadMore">
        <vs-button color="primary" :disable="isLoading" @click="loadMore" style="width: 150px">
          Load more
        </vs-button>
      </div>
    </div>
    <assetModal :item="isAssetModal" :withLink="true" v-if="isAssetModal" v-on:closeModal="closeAssetModal" :locale="filters.locale"
                :no-edit="true" :formatReference="filters && filters.goal && filters.goal.format_reference"  :show-metadata="!$store.state.user.hideMetadata" />
    <globalAssetModal :_item="isGlobalAssetModal" :withLink="true" v-if="isGlobalAssetModal"
                      :show-coobo-cdn-types="$route.meta.onlyUs ? ['cdn_url_without_anchor_without_voice'] : []"
                      :show-languages="!$route.meta.onlyUs"
                      v-on:closeModal="closeGlobalAssetModal" :show-metadata="!$store.state.user.hideMetadata"/>
    <powerSchoolers></powerSchoolers>
  </div>
</template>

<script>

import axios from "axios";
import vSelect from 'vue-select'
import GlobalAssetItem from "../components/GlobalAssetItem";
import CustomSvg from "../components/CustomSvg";
import assetModal from "../components/modal/assetModal";
import globalAssetModal from "../components/modal/globalAssetModal";
import powerSchoolers from "../components/modal/powerSchoolers";
import { quizes2D, quizes3D } from "@/utils/constants/quizTypes.js";
import defaultGoalsExams from "@/utils/constants/defaultGoalsExams.js";
import { getGoalsExamsSubjects } from "@/utils/fetchers/getGoalsExamsSubjects.js";
import { getUnits } from "@/utils/fetchers/getUnits.js";
import { hcLanguages } from "@/utils/constants/hcLanguages.js";
import SmartClickWrapper from "@/components/SmartClickWrapper.vue";

const quizTypeRegexp = new RegExp([...quizes3D,...quizes2D].join("|"), "gi");

export default {
  name: "GlobalSearch",
  components: {SmartClickWrapper, vSelect, GlobalAssetItem, CustomSvg, assetModal, globalAssetModal, powerSchoolers},
  props: {},
  data() {
    return {
      hcLanguages,
      filters: {
        _search: "",
        goal: '',
        exam: '',
        subject: "",
        unit: "",
        chapter: "",
        topic: "",
        title: "",
        licence: "",
        // asset_types: [],
        // _start: 0,
        // _limit: 27,
        imageType: "image",
        order_by: "updatedAt",
        order: "desc",
        academic_reviewed: 'any',
        artist_reviewed: 'any',
        visibility: 'any',
        // published: true,
        lm_format_id: '',
        lm_format: '',

        is_ar_links: 'any',
        is_animated: false,
        ar_reviewed: 'any',
        voiceover: "",
        locale: "en",
      },
      goalsExamsSubjects: [],
      goals: [],
      exams: [],
      subjects: [],
      units: [],
      chapters: [],
      topics: [],
      curriculums: [
        {value: "K12", name: "Teaching for school"},
        {value: "PreUG", name: "Teaching for college entrance exams"},
        {value: "PrePG", name: "Teaching for government service exams"}
      ],
      licences: [
        {value: "Embibe Internal", name: "Embibe Internal"},
        {value: "CC0/Public Domain", name: "CC0/Public Domain"},
        {value: "CC-BY", name: "CC-BY"},
        {value: "CC-SA", name: "CC-SA"},
        {value: "CC-ND", name: "CC-ND"},
        {value: "Purchased", name: "Purchased"}
      ],
      imageTypes: [
        {value: "image", name: "Image"},
        {value: "illustration", name: "Illustration"},
        {value: "cg_image", name: "CG Image"},
      ],
      types: [
        {value: "any", name: "Any"},
        {value: "simulations", name: "Virtual Labs"},
        {value: "videos", name: "Videos"},
        {value: "activities", name: "Activities"},
        {value: "3D", name: "3D Models"},
        {value: "coobos", name: "Lessons"},
        {value: "image", name: "Images"},
        // {value: "vr_image", name: "VR Images"},
        {value: "animation", name: "2D Animations"},
      ],
      items: [],
      currentPage: 1,
      totalItems_3D: 0,
      loadedItems_3D: 0,
      totalItems_Image: 0,
      loadedItems_Image: 0,
      totalItems_Animation: 0,
      loadedItems_Animation: 0,
      totalItems_Simulations: 0,
      loadedItems_Simulations: 0,
      totalItems_Coobos: 0,
      loadedItems_Coobos: 0,
      totalItems_Videos: 0,
      loadedItems_Videos: 0,
      totalItems_Activities: 0,
      loadedItems_Activities: 0,
      itemsPerPage: 15,
      totalPages: 0,
      showImages: true,
      isLoading: true,
      lmDebounce: false,
      lmFormats: [],
      cancelSearchToken: [],
      isAssetModal: false,
      isGlobalAssetModal: false,
      showLoadMore: false
    }
  },
  computed: {
    hcData() {
      return this.$store.state.hcData;
    },
    isHcLocale() {
      return hcLanguages.map(l => l.code).includes(this.filters.locale)
    },
    totalItemsAmp() {
      return  this.totalItems_3D + this.totalItems_Image + this.totalItems_Animation
    },
    totalItemsCount() {
      return this.totalItemsAmp + this.totalItems_Simulations + this.totalItems_Coobos + this.totalItems_Videos + this.totalItems_Activities;
    },
    isFullFilters() {
      const assetTypes = this.$store.state.globalSearchAssetTypes;
      return !assetTypes.length || assetTypes.some(t => !['simulations', 'coobos', 'activities', 'videos'].includes(t))
    },
    isReviewedFilters() {
      const assetTypes = this.$store.state.globalSearchAssetTypes;
      return !assetTypes.length || assetTypes.some(t => !['image', 'vr_image'].includes(t))
    },
    filtersObj() {
      return {
        user_id: this.$store.state.user._id,
        query: this.filters._search,
        goal: (this.filters.goal || {}).code || "",
        exam: (this.filters.exam || {}).code || "",
        subject: (this.filters.subject || {}).code || "",
        unit: (this.filters.unit || {}).id || "",
        chapter: (this.filters.chapter || {}).id || "",
        topic: (this.filters.topic || {}).id || "",
        title: this.filters.title,
        // asset_type: this.filters.asset_type,
        // asset_type: this.filters.asset_types.length ? this.filters.asset_types.join(',') : null,
        asset_type: this.$store.state.globalSearchAssetTypes.includes("any") ? [] : this.$store.state.globalSearchAssetTypes,
        // start: (this.currentPage - 1) * this.itemsPerPage,
        size: this.itemsPerPage,
        // order_by: this.filters.order_by,
        // order: this.filters.order,
        academic_reviewed: this.filters.academic_reviewed,
        artist_reviewed: this.filters.artist_reviewed,
        visibility: this.filters.visibility,
        published: this.$store.state.globalSearchPublished,
        is_ar_links: this.filters.is_ar_links,
        is_animated: this.filters.is_animated,
        ar_reviewed: this.filters.ar_reviewed,
        licence: this.filters.licence,
        locale: this.filters.locale,
        // voiceover: this.filters.voiceover,
        // lm_format_id: this.filters.lm_format_id,
      }
    },
    filtersQuery() {
      return Object.keys(this.filtersObj)
        .filter(k => k !== "locale")
        .filter(k => (k === 'query' && this.filtersObj[k]) || (!this.filtersObj.topic || !['goal', 'exam', 'subject', 'unit', 'chapter', 'topic'].includes(k)) && (k !=='is_animated' || this.filtersObj.asset_type.includes('3D')) && (Boolean(this.filtersObj[k]) && this.filtersObj[k] !== 'any' || this.filtersObj[k] === 0 || (k === 'academic_reviewed' || k === 'artist_reviewed' || k === 'published' || k === 'is_ar_links' || k === 'ar_reviewed') && this.filtersObj[k] !== 'any'))
        .map(k => {
          if (['academic_reviewed', 'artist_reviewed', 'visibility', 'published', 'is_ar_links', 'ar_reviewed', 'is_animated'].indexOf(k) !== -1) {
            return `filter=${k}:${this.filtersObj[k]}`
          } else if (['goal', 'exam', 'subject', 'unit', 'chapter'].indexOf(k) !== -1) {
            return `filter=${k}_code.keyword:${this.filtersObj[k]}`
          } else {
            return `${k}=${this.filtersObj[k]}`
          }
        }).join("&")
    },
    filtersFsMsQuery() {
      return Object.keys(this.filtersObj).filter(k => !['goal', 'grade', 'subject', 'unit', 'chapter', 'topic', 'user_id', 'asset_type', 'query'].includes(k) && (Boolean(this.filtersObj[k]) && this.filtersObj[k] !== 'any' || this.filtersObj[k] === 0 || (k === 'academic_reviewed' || k === 'artist_reviewed' || k === 'published' || k === 'is_ar_links' || k === 'ar_reviewed') && this.filtersObj[k] !== 'any')).map(k => ['academic_reviewed', 'artist_reviewed', 'visibility', 'published', 'is_ar_links', 'ar_reviewed'].indexOf(k) !== -1 ? `filter=${k}:${this.filtersObj[k]}` : `${k}=${this.filtersObj[k]}`).join("&")
    },
    learnpathName() {
      return Object.keys(this.filtersObj).filter(k => (k === 'goal' || k === 'grade' || k === 'subject' || k === 'unit' || k === 'chapter' || k === 'topic') && Boolean(this.filtersObj[k])).map(k => `${this.filtersObj[k].toLowerCase()}`).join("--")
    }
  },
  mounted() {
    console.log(this.$route);
    getGoalsExamsSubjects(this.$route.meta.filterLm, {allowEmpty: this.$route.meta.allowEmpty}).then(data => {
      this.goalsExamsSubjects = data;
    })
    this.getEmbibeToken();
    axios.get("/data.json").then((data) => {
      this.$store.commit("setState", {hcData: data.data});
      this.fetchItems();
    })
  },
  destroyed() {
    let types = JSON.parse(JSON.stringify(this.$store.state.typeFilters));
    for (let k in types) {
      types[k] = false;
    }

    this.$store.commit("setState", {typeFilters: types});
  },
  watch: {
    filtersObj(next, prev) {
      if (this.items.length) {
        // this.items = [];
        this.totalPages = 0;
      }
      // if (!compareObjects(next, prev)) {
      //     this.fetchItems()
      // }
    }
  },
  methods: {
    analytics(payload) {
      const filters = {...this.filtersObj};
      delete filters.size;
      const data = {
        app_name: "amp",
        timestamp: Date.now().toString(),
        ...filters,
        asset_type: [...this.$store.state.globalSearchAssetTypes],
        ...payload,

      }
      console.log(data);
      const url = "https://beta-api.embibe.com/de/events/push/v2?namespace=prod-embibe-clickstream-events&topic=prod-embibe-clickstream-interaction-events-web";
      axios.post(url, data);
    },
    getEmbibeToken() {
      this.$axios.request({
        method: 'post',
        url: 'https://beta-api.embibe.com/coobo_ms/licence-keys/activate?locale=en',
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        data: JSON.stringify({"licence_key": "111111111111", "device_id": "uhktr"})
      }).then(res => {
        // console.log(res);
      })
    },
    onLangChange(l) {
      if (hcLanguages.map(l => l.code).includes(l) && !this.$store.state.globalSearchAssetTypes.some(t => this.hcData[t])) {
        this.toggleMediaType("any");
        this.fetchItems(false);
      } else {
        this.fetchItems(false);
      }
    },
    showGlobalAsset(item) {
      this.analytics({
        eventName: "ASSET_CLICK",
        content_id: item.asset_object_id || item.id || item.video_id,
        title: item.title || item.name,
        goal: item.display_goal || "",
        exam: item.display_exam || "",
        unit: item.display_unit || "",
        chapter: item.display_chapter || "",
        topic: item.display_topic || ""
      })
      console.log(item);
      if (item.asset_object_id) {
        this.isAssetModal = item;
      } else {
        this.isGlobalAssetModal = {...item, language: this.filtersObj.locale};
      }
    },
    closeAssetModal() {
      this.isAssetModal = false;
    },
    closeGlobalAssetModal() {
      this.isGlobalAssetModal = false;
    },
    // updateSearch() {
    //   if (this.$store.state.searchQuery) {
    //     this.filters._search = this.$store.state.searchQuery;
    //     this.$store.commit("setState", {searchQuery: ''});
    //     this.handlePaginationChange();
    //   }
    // },
    loadMore() {
      this.currentPage++;
      this.fetchItems(true);
    },
    getLMFormats() {
      let url = `/lm-formats?lm_type=learning_map` + '&search=' + '';
      this.$axios.get(url).then(res => {
        this.lmFormats = res.data._items;
      }).catch(e => {
        console.log(url, e.message)
      })
    },
    setRadioBtn(type, val) {
      if (type === "published") {
        this.$store.commit("setState", {globalSearchPublished: val});
      } else if (type === 'asset_type') {
        let types = JSON.parse(JSON.stringify(this.$store.state.typeFilters));
        for (let k in types) {
          types[k] = val === k;
        }
        this.$store.commit("setState", {typeFilters: types});
        this.filters[type] = val;
      } else {
        this.filters[type] = val;
      }
      this.fetchItems();
    },
    toggleMediaType(type) {
      const ind = this.$store.state.globalSearchAssetTypes.indexOf(type);
      this.$store.commit("setState", {globalSearchAssetTypes: type ? [type] : []});
      const voiceOverValues = {
        any: "",
        simulations: "yes",
        videos: "yes",
        activities: "no",
        "3D": "no",
        coobos: "",
        image: "no",
        animation: "no",
      }
      this.filters.voiceover = voiceOverValues[type];
      if (type && ind === -1) this.fetchItems(false)
    },
    clear(fieldName) {
      const map = ['goals', 'exams', 'subjects', 'units', 'chapters', 'topics'].reverse();
      const clearMap = {
        goals: () => {
          this.goals = [];
          this.filters.goal = ''
        },
        exams: () => {
          this.exams = [];
          this.filters.exam = ''
        },
        subjects: () => {
          this.subjects = [];
          this.filters.subject = ''
        },
        units: () => {
          this.units = [];
          this.filters.unit = ''
        },
        chapters: () => {
          this.chapters = [];
          this.filters.chapter = ''
        },
        topics: () => {
          this.topics = [];
          this.filters.topic = ''
        },
      }
      let ind = map.indexOf(fieldName);
      // this.items = [];
      this.currentPage = 1;
      this.totalPages = 0;
      if (ind < 0) return;
      for (let i = 0; i <= ind; i++) {
        clearMap[map[i]]();
      }
    },
    selectCurriculum(curriculum) {
      this.filters.lm_format = curriculum;
      this.clear("goals");
      if(curriculum) {
        this.goals = this.goalsExamsSubjects.filter(g => g.type === curriculum.value);
      }
    },
    selectGoal(goal) {
      this.filters.goal = goal;
      this.clear("exams");
      if (goal) {
        this.exams = goal.exam.filter(e => e.subjects && e.subjects.length);
      }
      this.fetchItems();
    },
    selectExam(exam) {
      this.filters.exam = exam;
      this.clear("subjects");
      if (exam) {
        this.subjects = exam.subjects;
      }
      this.fetchItems();
    },
    selectSubject(subject) {
      this.filters.subject = subject;
      this.clear("units");
      if (subject) {
        getUnits(subject.code, this.filtersObj.locale).then((units) => {
          this.units = units;
        });
      }
      this.fetchItems();
    },
    selectUnit(unit) {
      this.filters.unit = unit;
      this.clear("chapters");
      if (unit) {
        this.chapters = unit.children;
      }
      this.fetchItems();
    },
    selectChapter(chapter) {
      this.filters.chapter = chapter;
      this.clear("topics");
      if (chapter) {
        this.topics = chapter.children;
      }
      this.fetchItems();
    },
    selectTopic(topic) {
      this.filters.topic = topic;
      this.fetchItems();
    },
    getTopics() {
      this.clear("topics");
      let url = `/topics-list?id=${this.filters.lm_format_id}`;
      url += '&goal=' + this.filters.goal;
      url += '&exam=' + this.filters.exam;
      url += '&subject=' + this.filters.subject;
      url += '&unit=' + this.filters.unit;
      url += '&chapter=' + this.filters.chapter;
      this.$axios.get(url).then(res => {
        this.topics = Object.values(res.data)[0];
      }).catch(e => {
        console.log(url, e.message)
      })
    },
    clearSearch() {
      this.filters._search = "";
      this.isLoading = false;
      if (this.cancelSearchToken && this.cancelSearchToken.length && this.cancelSearchToken[0].cancel) {
        this.cancelSearchToken[0].cancel({err: "Operation canceled by user action."});
      }
      this.fetchItems(false);
    },
    handlePaginationChange(page) {
      if (page !== this.currentPage) {
        this.fetchItems();
      }
    },
    hcSearch(facet, opts) {
      const _facet = facet === "activities" ? "coobos" : facet;
      const locale = opts.locale || this.filters.locale;
      const items = (this.hcData[facet] || [])
        .filter(item => item.language === locale)
        .map(item => {
        item.asset_type = _facet;
        item.subtype = facet;
        item.thumbnail = item.thumbnail || item["thumbnail/landscape"] || item["thumbnail/portrait"]
        if (facet === "activities") {
          item.quizType = opts.search || (item.description.match(quizTypeRegexp) || [])[0];
        }
        return item;
      })
      return Promise.resolve({items, count: items.length, assetType: facet});
    },
    getAssetCount(no_of_results, assetType) {
      let count = no_of_results;
      const overrideCounters = {
        lessons: { condition: n => n === 10000, count: 11228 },
        coobos: { condition: n => n === 10000, count: 11228 },
        activities: { condition: n => n === 10000, count: 9181 },
        videos: { condition: n => n > 7000, count: 15619 },
        simulations: { condition: n => n > 600, count: 723 },
      }
      if (overrideCounters[assetType] && overrideCounters[assetType].condition(no_of_results)) {
        count = overrideCounters[assetType].count;
      }
      return count;
    },
    fsMsSearch(facet, opts = {}) {
      const locale = opts.locale || this.filters.locale;
      if (this.hcLanguages.map(l => l.code).includes(locale)) {
        return this.hcSearch(facet, opts);
      }
      return new Promise(resolve => {
        const _facet = facet === "activities" ? "coobos" : facet;
        const filters = this.filtersObj;
        const user_goal = (this.filters.goal || {}).display_name || (defaultGoalsExams[filters.locale] || defaultGoalsExams.en).user_goal;
        const user_exam = (this.filters.exam || {}).display_name || (defaultGoalsExams[filters.locale] || defaultGoalsExams.en).user_exam;
        const size = opts.size || this.itemsPerPage
        const query = [
          `facet=${_facet}`,
          `size=${size}`,
          `start=${(this.currentPage - 1) * size}`,
          `locale=${filters.locale}`,
          `cross_grade=true`,
          `user_id=1234`,
          `sort_by=default`,
          `user_goal=${user_goal.toLowerCase()}`,
          `user_exam=${user_exam.toLowerCase()}`,
          // filters.subject ? `filter=subject.keyword:${filters.subject}` : "",
          filters.licence ? `licence=${filters.licence}` : "",
          facet === "activities" ? "filter=category.keyword:Interactive Question" : "",
          `query=${opts.search || filters.query || '*'}`,
          this.$route.meta.filterLm ? `filter=goal_code.keyword:kve17177619` : "",
          filters.goal ? `filter=goal_code.keyword:${filters.goal}` : "",
          filters.exam ? `filter=exam_code.keyword:${filters.exam}` : "",
          filters.subject ? `filter=subject_code.keyword:${filters.subject}` : "",
          filters.unit ? `filter=unit_code.keyword:${filters.unit}` : "",
          filters.chapter ? `filter=chapter_code.keyword:${filters.chapter}` : "",
          filters.topic ? `filter=topic_code.keyword:${filters.topic}` : "",
          `app_name=amp`,
          ...(facet === "coobos" ? ["filter=category.keyword:Topic Explainer", "filter=type:manual"] : []),
          ...(filters.voiceover && filters.voiceover === 'no' && (_facet === "coobos") ? ["filter=cdn_url_with_anchor.keyword:", "filter=cdn_url_without_anchor.keyword:"] : []),
          ...(filters.voiceover && filters.voiceover === 'no' && (_facet === "videos") ? ["filter=cdn_url.keyword:", "filter=cdn_url_no_anchor.keyword:"] : []),
          ...(facet === "videos" ? ["filter=source:vimeo", "filter=source:designmate", "filter=source:mlearning"] : []),
          // ...(facet === "videos" && !filters.query ? [ "filter=subject.keyword:science", "filter=subject.keyword:mathematics"] : [])
        ].filter(s => s).join("&")
        let url = `https://${facet === "simulations" ? "beta-api" : "preprodms"}.embibe.com/fs_ms/v2/search?${query}`
        this.$axios.get(url).then(res => {
          let items = [];
          let count = 0;
          if (res.data && res.data.results && res.data.results[0]){
            if (res.data.results[0].content && res.data.results[0].content.length) {
              items = res.data.results[0].content.map(item => {
                item.asset_type = _facet;
                item.subtype = facet;
                if (_facet === 'coobos') {
                  item.thumbnail = item.thumbnail.portrait;
                }
                if (facet === "activities") {
                  item.quizType = opts.search || (item.description.match(quizTypeRegexp) || [])[0];
                }
                return item;
              })
              // if (facet === "activities" && !opts.search) {
              //   items = items
              //     .filter(q => q.quizType)
              //     .sort((q) => quizes3D.map(s => s.toLowerCase()).includes(q.quizType.toLowerCase()) ? -1 : 1)
              // }
            }
            if (res.data.results[0].no_of_results) {
              count = res.data.results[0].no_of_results;
            }
          }
          resolve({items, count, assetType: facet})
        }).catch(e => {
          console.log('catch_search', e)
          this.isLoading = Boolean(e.message.newSearch);
          this.$root.removeLoading('#search-btn');
          if (this.cancelSearchToken && this.cancelSearchToken[0]) {
            this.cancelSearchToken = this.cancelSearchToken.slice(1);
          }
          resolve({error: true})
        })
      })
    },
    ampSearch(assetType) {
      const hcLang = this.hcLanguages.find(l => l.code === this.filters.locale);
      if (hcLang && !hcLang.ampSearchLocale) {
        return this.hcSearch(assetType);
      }
      return new Promise(resolve => {
        const kveCode = this.filtersObj.topic;
        if (this.cancelSearchToken && this.cancelSearchToken[0] && this.cancelSearchToken[0].cancel) {
          this.cancelSearchToken[0].cancel({err: "Operation canceled by new search.", newSearch: true});
        }
        this.cancelSearchToken = axios.CancelToken.source();
        let asset_types = [assetType];
        if (assetType === "image") {
          asset_types = this.$store.state.globalSearchAssetTypes.includes("any")
            ? ["image", "illustration", "cg_image"]
            : [this.filters.imageType];
        }
        const locale = (hcLang || {}).ampSearchLocale || this.filters.locale;
        const query = [
          this.filtersQuery,
          ...asset_types.map(asset_type => `filter=asset_type:${asset_type}`),
          kveCode ? `filter=meta_kve_codes.keyword:${kveCode}` : "",
          `start=${(this.currentPage - 1) * this.itemsPerPage}`,
          `app_name=amp`,
          `locale=${locale}`,
          this.$route.meta.filterLm ? `filter=goal_code.keyword:kve17177619` : "",
          `sort_by=default`,
          `user_id=1234`
        ].filter(s => s).join("&");
        const url = `${this.$route.name === 'advancedSearchNew' ? 'https://beta-api.embibe.com' : 'https://preprodms.embibe.com'}/fs_ms/v2/ampsearch?${query}`

        this.$axios.get(url, {cancelToken: this.cancelSearchToken.token}).then(res => {
          let items = [];
          let count = []
          if (res.data && res.data.content && res.data.content.length) {
            items = res.data.content;
          }
          if (res.data && res.data.metadata) {
            count = res.data.metadata.total
          }

          if (this.cancelSearchToken && this.cancelSearchToken[0]) {
            this.cancelSearchToken = this.cancelSearchToken.slice(1);
          }
          resolve({items, count, assetType})
        }).catch(e => {
          console.log('catch_search', e)
          this.isLoading = Boolean(e.message.newSearch);
          this.$root.removeLoading('#search-btn');
          if (this.cancelSearchToken && this.cancelSearchToken[0]) {
            this.cancelSearchToken = this.cancelSearchToken.slice(1);
          }
          resolve({error: true})
        })
      })
    },
    resetCounters() {
      this.totalItems_3D = 0;
      this.loadedItems_3D = 0;
      this.totalItems_Image = 0;
      this.loadedItems_Image = 0;
      this.totalItems_Animation = 0;
      this.loadedItems_Animation = 0;
      this.totalItems_Simulations = 0;
      this.loadedItems_Simulations = 0;
      this.totalItems_Coobos = 0;
      this.loadedItems_Coobos = 0;
      this.totalItems_Videos = 0;
      this.loadedItems_Videos = 0;
      this.totalItems_Activities = 0;
      this.loadedItems_Activities = 0;
    },
    fetchActivities() {
      return Promise.all(['*', ...quizes3D,...quizes2D].map((search, i) => {
        const opts = {search, size: i ? 3 : 1}
        return this.fsMsSearch('activities', opts)
      })).then((responses) => {
        this.totalItems_Activities = this.getAssetCount(responses[0].count || 0, 'activities');
        return {
          count: responses[0].count || 0,
          assetType: 'activities',
          items: responses.slice(1).map(r => r.items || []).flat()
        };
      })
    },
    capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    hasMore(assetType) {
      const capitalizedAssetType = this.capitalize(assetType);
      const totalItemsKey = `totalItems_${capitalizedAssetType}`;
      const loadedItemsKey = `loadedItems_${capitalizedAssetType}`;
      return this[loadedItemsKey] < this[totalItemsKey]
    },
    fetchItems(loadMore = false) {
      const filters = this.filtersObj;
      // if (this.filters._search.length < 3) return;
      this.isLoading = true;
      this.$root.addLoading('#search-btn');
      clearTimeout(this.fetchDebounce);
      this.fetchDebounce = setTimeout(() => {
        if (!loadMore) {
          this.items = [];
          this.currentPage = 1;
          this.resetCounters()
        }
        if (filters.licence && filters.licence !== 'Embibe Internal') {
          this.items = [];
          this.currentPage = 1;
          this.resetCounters();
          this.isLoading = false;
          this.$root.removeLoading('#search-btn');
        } else {
          // let langMatch = filters.query.match(/[a-zA-Z0-9_]/g);
          // let lang = !filters.query || langMatch ? 'en' : 'hi';
          let promises = [];
          const asset_types = this.$store.state.globalSearchAssetTypes;
          const videosOpts = this.$route.meta.onlyUs ? {locale: "English (US)"} : {};
          if (asset_types && asset_types.length && !asset_types.includes("any")) {
            const ampTypes = ['3D', 'image', 'vr_image', 'animation'];
            const selectedAmpTypes = asset_types.filter(t => ampTypes.includes(t));

            if (selectedAmpTypes.length) {
              promises.push(...selectedAmpTypes.map(t => this.ampSearch(t)))
            }
            if (asset_types.includes('simulations')) {
              promises.push(this.fsMsSearch('simulations'))
            }
            if (asset_types.includes('coobos')) {
              promises.push(this.fsMsSearch('coobos'))
            }
            if (asset_types.includes('activities')) {
              if (filters.query || this.hcLanguages.map(l => l.code).includes(this.filters.locale)) {
                promises.push(this.fsMsSearch('activities'))
              } else {
                // promises.push(this.fetchActivities())
                promises.push(this.fsMsSearch('activities'));
              }
            }
            if (asset_types.includes('videos')) {
              promises.push(this.fsMsSearch('videos', videosOpts))
            }
          } else {
            if(!loadMore || this.hasMore('simulations')) promises.push(this.fsMsSearch('simulations'));
            if(!loadMore || this.hasMore('videos')) promises.push(this.fsMsSearch('videos', videosOpts));
            if(!loadMore || this.hasMore('activities')) promises.push(this.fsMsSearch('activities'));
            if(!loadMore || this.hasMore('3D')) promises.push(this.ampSearch("3D"));
            if(!loadMore || this.hasMore('coobos')) promises.push(this.fsMsSearch('coobos'))
            if(!loadMore || this.hasMore('image')) promises.push(this.ampSearch("image"));
            if(!loadMore || this.hasMore('animation')) promises.push(this.ampSearch("animation"));
          }
          this.analytics({eventName: "FETCH_ITEMS", loadMore});
          Promise.all(promises).then((results) => {
            this.items.push(...results.map(r => r.items || []).flat());
            let showLoadMore = false;
            results.forEach(r => {
              if (r.assetType) {
                const capitalizedAssetType = this.capitalize(r.assetType);
                const totalItemsKey = `totalItems_${capitalizedAssetType}`;
                const loadedItemsKey = `loadedItems_${capitalizedAssetType}`;
                if ("count" in r) {
                  this[totalItemsKey] = this.getAssetCount(r.count, r.assetType);
                }
                if ('items' in r && r.items.length) {
                  this[loadedItemsKey] += r.items.length;
                }
                if (this[loadedItemsKey] < this[totalItemsKey]) {
                  showLoadMore = true;
                }
              }
            })
            this.showLoadMore = showLoadMore;
            this.isLoading = false;
            this.$root.removeLoading('#search-btn');
          })
        }
      }, 500)
    },
  },
}

function compareObjects(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
}
</script>

<style>
.advanced-search .label {
  width: 95px;
}
.v-select .vs__dropdown-menu .vs__dropdown-option {
  word-break: normal;
}
</style>
